import { Linking, ScrollView, StyleSheet, Text, View } from 'react-native';
import React, { FC, useCallback, useEffect, useState } from 'react';
import PageTitle from '../../components/PageTitle';
import { Footer } from '../../components/Footer';
import ServiceItem from './components/ServiceItem';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { ClubServiceLayout } from '../../WebLayout';
import { IS_WEB } from '../../constants/platform';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { services_forms_icon } from '../../assets/base64';
import ServicesApi, { ServiceFormProps } from '../../services/api/services.api';
import { IServiceForm } from '../../types/services.types';
import { Loading } from '../../components';
import { COLORS, FONTS } from '../../constants';

const ServicesForms: FC = () => {
  const description: string =
    'IF YOU WISH TO APPLY, SIMPLY SUBMIT A COMPLETED APPLICATION FORM TOGETHER WITH THE DOCUMENTS REQUIRED (IF ANY)';
  const isDesktop = useIsDesktop();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [serviceForms, setServiceForms] = useState<IServiceForm[]>([]);

  const getServiceForms = useCallback(async (props: ServiceFormProps) => {
    try {
      setIsLoading(true);
      const res = await ServicesApi.getServiceForms(props);
      setServiceForms(res.data.service_forms);
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getServiceForms({});
  }, [getServiceForms]);

  if (isDesktop()) {
    return (
      <ClubServiceLayout
        title="Service And Forms"
        current={0}
        icon={
          IS_WEB
            ? addBase64Prefix(services_forms_icon)
            : require('../../assets/services-forms-icon.png')
        }
        description={description}
      >
        {isLoading === true && <Loading />}
        {serviceForms.length > 0 && (
          <View
            style={{
              flexWrap: 'wrap',
              flexDirection: 'row',
              rowGap: 40,
              marginBottom: 60,
            }}
          >
            {serviceForms.map((item, index) => (
              <View
                key={index}
                style={{ width: '33.33333333%', paddingHorizontal: 30 }}
              >
                <ServiceItem item={item} />
              </View>
            ))}
          </View>
        )}
        {isLoading === false && serviceForms.length === 0 ? (
          <View style={styles.noDataWrapper}>
            <Text style={[styles.noDataText, { fontSize: 20 }]}>
              THERE ARE CURRENTLY NO SERVICE FORM
            </Text>
          </View>
        ) : (
          <></>
        )}
      </ClubServiceLayout>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={styles.container}>
        <PageTitle
          title="Services & Forms"
          icon={require('../../assets/services-forms-icon.png')}
          description={description}
          haveGoBackButton={true}
        />
      </View>
      <View style={styles.container}>
        {isLoading === true && (
          <View style={{ marginBottom: 20 }}>
            <Loading />
          </View>
        )}
        {serviceForms.length > 0 && (
          <View
            style={{
              flexWrap: 'wrap',
              flexDirection: 'row',
              rowGap: 25,
              marginBottom: 50,
            }}
          >
            {serviceForms.map((item, index) => (
              <View
                key={index}
                style={{
                  width:
                    index === serviceForms.length - 1 &&
                    serviceForms.length % 2 === 1
                      ? '100%'
                      : '50%',
                  paddingHorizontal: 10,
                  alignItems:
                    serviceForms.length - 1 && serviceForms.length % 2 === 1
                      ? 'center'
                      : undefined,
                }}
              >
                <View
                  style={{
                    width:
                      index === serviceForms.length - 1 &&
                      serviceForms.length % 2 === 1
                        ? '50%'
                        : '100%',
                  }}
                >
                  <ServiceItem item={item} />
                </View>
              </View>
            ))}
          </View>
        )}
        {isLoading === false && serviceForms.length === 0 ? (
          <View style={styles.noDataWrapper}>
            <Text style={[styles.noDataText, { fontSize: 16 }]}>
              THERE ARE CURRENTLY NO SERVICE FORM
            </Text>
          </View>
        ) : (
          <></>
        )}
      </View>
      <Footer />
    </ScrollView>
  );
};

export default ServicesForms;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
  noDataWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingVertical: 20,
  },
  noDataText: {
    color: COLORS.GREEN,
    textTransform: 'uppercase',
    fontFamily: FONTS.AvenirMedium,
  },
});
